module.exports = __webpack_public_path__ + "img/can.77a26c55.png";